import {Config} from '../../../types'

export const PRODUCTION_DAY_DEFAULTS = {
  START_TIME: '00:00',
  END_TIME: '00:00'
} as const

/**
 * Ensures production day time values have valid defaults
 */
export const normalizeProductionDayTimes = (config: Config): Config => {
  return {
    ...config,
    productionDayStartTime: config.productionDayStartTime || PRODUCTION_DAY_DEFAULTS.START_TIME,
    productionDayEndTime: config.productionDayEndTime || PRODUCTION_DAY_DEFAULTS.END_TIME
  }
}

/**
 * Determines if production day time fields should be disabled
 */
export const shouldDisableProductionDayTimeField = (
  fieldName: string,
  useCustomBoundaries: string
): boolean => {
  // End time is always read-only
  if (fieldName === 'productionDayEndTime') {
    return true
  }

  // Start time is disabled when custom boundaries are not enabled
  if (fieldName === 'productionDayStartTime') {
    return useCustomBoundaries !== 'true'
  }

  return false
}
